var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ma-auto",attrs:{"small":"","elevation":"0","color":"error"},on:{"click":_vm.submit}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v("mdi-shield-alert")]),_vm._v(" Verify email address ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }